<div class="app-container">
  <div class="centered-content">
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
    <app-footer [noMargin]="isUnimarc"></app-footer>
  </div>
</div>
